const moment = require('moment')
const simple = (value, toCompare) => value <= toCompare

const date = (value, toCompare) => {
  if (moment(toCompare, moment.ISO_8601, true).isValid()) {
    return simple(new Date(value), new Date(toCompare))
  }

  if (!isNaN(parseFloat(toCompare))) {
    let future = new Date(moment(value).utc()).getTime()
    let now = new Date(moment.utc()).getTime()

    return simple(now - future, parseFloat(toCompare) * 1000)
  }
}

module.exports = (value, toCompare) => {
  return moment(value, moment.ISO_8601, true).isValid()
    ? date(value, toCompare)
    : simple(value, toCompare)
}
